import { useCallback } from 'react'
import { generatePath, useHistory } from 'react-router-dom'
import Icon from '@mdi/react'
import { mdiWifi } from '@mdi/js'

import { useNetworkHomeJobsRouteParams } from 'features/networkAi/hooks'
import routes from 'app/routes'
import { CreateWLANsWhiteBlock } from '../styles'
import {
  CreateWLANsActionsBody,
  CreateWLANsActionsButton,
  CreateWLANsActionsContainer,
  CreateWLANsActionsHeader,
  CreateWLANsActionsTitle,
} from './styles'

function CreateWLANsActions() {
  const { rootDomainId, homeId, jobId } = useNetworkHomeJobsRouteParams()
  const history = useHistory()

  const handleClickToCreateWlan = useCallback(() => {
    const path = generatePath(routes.networkAi.wizard.createWLANsSetup, {
      rootDomainId,
      jobId,
      homeId,
    })

    history.push(path)
  }, [history, homeId, jobId, rootDomainId])

  const handleClickToSelectTemplate = useCallback(() => {
    const path = generatePath(routes.networkAi.wizard.selectTemplate, {
      rootDomainId,
      jobId,
      homeId,
    })

    history.push(path)
  }, [history, homeId, jobId, rootDomainId])

  const handleClickToCopyHome = useCallback(() => {
    const path = generatePath(routes.networkAi.wizard.copyHome, {
      rootDomainId,
      jobId,
      homeId,
    })

    history.push(path)
  }, [history, homeId, jobId, rootDomainId])

  return (
    <CreateWLANsWhiteBlock>
      <CreateWLANsActionsContainer>
        <CreateWLANsActionsHeader>
          <Icon path={mdiWifi} size={3} />
          <CreateWLANsActionsTitle>WLANs</CreateWLANsActionsTitle>
        </CreateWLANsActionsHeader>
        <CreateWLANsActionsBody>
          <CreateWLANsActionsButton
            variant="primary"
            type="button"
            onClick={handleClickToCreateWlan}
          >
            Create New
          </CreateWLANsActionsButton>

          <CreateWLANsActionsButton
            variant="secondary"
            type="button"
            onClick={handleClickToSelectTemplate}
          >
            From Template
          </CreateWLANsActionsButton>

          <CreateWLANsActionsButton
            variant="secondary"
            type="button"
            onClick={handleClickToCopyHome}
          >
            From Existing Home
          </CreateWLANsActionsButton>
        </CreateWLANsActionsBody>
      </CreateWLANsActionsContainer>
    </CreateWLANsWhiteBlock>
  )
}

export default CreateWLANsActions
